module.exports = __webpack_public_path__ + "img/dtu.299014fe.gif";